/**
 * HTML5 `pattern` for the task Title field: require at least one non-whitespace character so blank
 * / whitespace-only titles are rejected, while allowing any script, digits, or symbols. The old
 * `(.*[A-Za-z]+.*)` required an A-Za-z letter, which silently blocked form submission for valid
 * titles like "#2" or non-Latin text — the browser refused to submit with no visible feedback
 * (ENG-849).
 */
export const TASK_TITLE_PATTERN = '.*\\S.*'
